import { render, staticRenderFns } from "./DisplayExistingAdmins.vue?vue&type=template&id=3bab5604"
import script from "./DisplayExistingAdmins.vue?vue&type=script&lang=js"
export * from "./DisplayExistingAdmins.vue?vue&type=script&lang=js"
import style0 from "./DisplayExistingAdmins.vue?vue&type=style&index=0&id=3bab5604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports